import { StyleSheet, Text, View } from '@react-pdf/renderer'
import ReactPDFImage from 'src/features/reports/result/downloadPDF/ReactPDFImage'

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
})

type ImageSectionProps = {
  imageUrl?: string
  placeholder: string
  wrapperStyle: any
}

export const ImageSection = ({
  imageUrl,
  placeholder,
  wrapperStyle,
}: ImageSectionProps) => {
  if (!imageUrl) {
    return (
      <View style={wrapperStyle}>
        <Text style={{ textAlign: 'center', paddingTop: 40 }}>
          {placeholder}
        </Text>
      </View>
    )
  }

  return (
    <View>
      <View style={wrapperStyle}>
        <ReactPDFImage style={styles.image} uri={imageUrl} />
      </View>
    </View>
  )
}
